<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  import { isMobile } from '@/utils/device'
  export default {
    mounted() {
      this.$nextTick(() => {
        this.setHtmlFontSize()
      })
      window.addEventListener('resize', this.setHtmlFontSize)

      this.loginRoutTo()
    },
    activated() {
      this.setHtmlFontSize()
    },
    destroyed() {
      const htmlDom = document.getElementsByTagName('html')[0];
      htmlDom.style.removeProperty('font-size');
    },
    methods: {
      setHtmlFontSize() {
        const htmlDom = document.getElementsByTagName('html')[0];
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        if (htmlWidth >= 750) {
          htmlWidth = 750;
        }
        if (htmlWidth <= 320) {
          htmlWidth = 320;
        }
        htmlDom.style.fontSize = `${htmlWidth / 7.5}px`;

        let bodyStyle = document.body.style
        bodyStyle.fontSize = '14px'
      },
      loginRoutTo() {
        // let pathstr = this.$route.path;
        // if (isMobile() && !pathstr.includes('H5')) {
        //   // 切换到手机端路由
        //   this.$router.replace('/H5/login');
        // } 
      }
    }
  }
</script>

<style lang="scss">
</style>
